import { memo } from 'react';

import { appealStatusSelectOptions } from 'KnmErknmPackage/MainModule/constants/appealStatusSelectOptions';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { Section } from 'UIPackage/FormModule/components/Section';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';

interface IErknmAppealStatus {
  watchOnlyExtended: boolean;
}

export const ErknmAppealStatus = memo(({ watchOnlyExtended }: IErknmAppealStatus) => {
  return (
    <Section title="Сведения об обжаловании решений и действий по результатам КНМ">
      <FieldBlock>
        <SelectInputField
          name="appealStatus"
          size="medium"
          options={appealStatusSelectOptions}
          disabled={watchOnlyExtended}
          isClearable={false}
        />
      </FieldBlock>
    </Section>
  );
});
